export const styles = {
  root: {
    padding: '12px',
    borderRadius: '4px',
    backgroundColor: '#D9D9D9',
  },
}
